'use strict';

customerZone

.directive('selectOptions', ['config', function(config) {

    var controller = ['$scope', '$q', '$log', '$attrs', '$location', '$route', 'utils',
        function(scope, $q, $log, $attrs, $location, $route, utils){

            var self = this;
            self.allowMultiSelect = !!$attrs['multiselect'];

            self.optionsCategories = [];
            scope.$watch(function(){ return self.options; }, function(){
                if (!self.options) return;
                var byType = group(self.options, function(p){ return p.type; });
                self.optionsCategories = Object.keys(byType).map(function(type){
                    var products = byType[type];
                    return {
                        title: products[0].category || products[0].type,
                        products: products
                    };
                });
            });

            self.toggleOption = function(product){
                if (self.optionPicked(product))
                    unpickProduct(product);
                else
                    pickProduct(product);
            };

            self.optionPicked = function(product){
                return self.selection.indexOf(product)>=0;
            };

            var pickProduct = function(product){
                if (self.allowMultiSelect){
                    if (!checkBudget(total() + product.price)) return;
                    self.selection.push(product);
                }
                else {
                    if (!checkBudget(product.price)) return;
                    self.selection = [product];
                }
            };

            var unpickProduct = function(product){
                var idx = self.selection.indexOf(product);
                self.selection.splice(idx, 1);
            };

            var total = function(){
                var r = 0;
                self.selection.forEach(function(option){ if (option.price) r+= option.price; });
                return r;
            };

            /**
             * Check if the user has enough budget for a change.  If not, also show an error.
             */
            var checkBudget = function(required){
                if (self.budget === undefined) return true;
                if (required > self.budget) {
                    utils.showError('insufficient_credit_for_order');
                    return false;
                }
                else return true;
            };
        }];


    var group = function(array, qualifier){
        var result = {};
        array.forEach(function(entry){
            var key = qualifier(entry);
            var group = result[key];
            if (group === undefined){
                group = [];
                result[key] = group;
            }
            group.push(entry);
        });
        return result;
    };

    return {
        scope: {options: '=', budget: '=', selection: '='},
        controller: controller,
        controllerAs: 'eservice',
        bindToController: true,
        templateUrl: config.baseUrl+'/views/selectOptions.partial.html'
    };
}]);
